import React from 'react';
import { Link } from '@inertiajs/react';

export function Footer() {
  return (
    <footer className="relative py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center text-center">
          <p className="text-sm text-blue-800 mb-4" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 'normal' }}>
            &copy; Protribe {new Date().getFullYear()}
          </p>

          <div className="flex space-x-6">
            <Link href="/privacy" className="text-xs text-blue-800 hover:text-blue-600 transition-colors" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 'normal' }}>
              Privacy Policy
            </Link>
            <Link href="/terms" className="text-xs text-blue-800 hover:text-blue-600 transition-colors" style={{ fontFamily: 'Inter, sans-serif', fontWeight: 'normal' }}>
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
} 